const controller = 'Mating';

/** Permission names exposed by the mating module. */
export const matingPermissions = {
    mating: `${controller}/Mating`,
};
